export enum DocumentRequestedEnum {
  'AFFILIATE' = 'AFFILIATE',
  'VEHICLE' = 'VEHICLE',
  'DRIVER' = 'DRIVER',
  'COMPANY' = 'COMPANY',
}
